/**
 * @ignore
 * Created by daletan on 8/24/16.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');
const Page = require('./index.es');

const { getEnvironment } = require('../global/relayEnvironmnentProvider.es').default;

const { getUserId, cookieJarConstants } = require('dibs-cookie-jar');
const { MASQUERADE_BUYER } = cookieJarConstants;

const { createStore, combineReducers } = require('redux');
const { Provider } = require('react-redux');
const { reducers: shippingQuoteModal } = require('dibs-request-shipping-modal');

const NewPdpRoot = (props) => {
    const userId = getUserId(document.cookie, MASQUERADE_BUYER);
    const queryConfig = {
        name: 'NewPdpContainer',
        queries: {
            viewer: (Component, params) => Relay.QL`
            query {
                viewer {
                    ${Component.getFragment('viewer', params)}
                }
            }
            `
        },
        params: {
            userId
        }
    };
    return (
        // Redux store is for shipping quote request modal, which needs to maintain its state through forceUpdateFromUserLogin
        // Todo: Is store still needed now that forceUpdateFromUserLogin isn't necessary?
        <Provider store={createStore(combineReducers({shippingQuoteModal}))}>
            <Relay.Renderer
                Container={Page}
                environment={getEnvironment()}
                queryConfig={queryConfig}
                render={({ props: queryProps }) => { //eslint-disable-line react/display-name, react/prop-types
                    if (queryProps) {
                        return <Page {...queryProps} {...props} context={props.context}/>;
                    }
                    // return with null viewer so the entire page does not flash
                    return <Page viewer={null} {...props} context={props.context}/>;
                }}
            />
        </Provider>
    );
};

NewPdpRoot.propTypes = {
    context: PropTypes.object.isRequired
};

module.exports = NewPdpRoot;



// WEBPACK FOOTER //
// ./assets/js/newPdp/NewPdpRoot.jsx